module.exports = __webpack_public_path__ + "static/Wrapbook-748cea406a592301558ba5d696bffc80.jpg";